import React from "react";
import SectionHeader from "../../components/SectionHeader";
import Section from "../../components/Section";
import QuizQuestionPreview from "../../components/QuizQuestionPreview";
import QuizAnswers from "../../components/QuizAnswers";
import quiz from "../story-quiz/quiz.json";
import quizImageMap from "../story-quiz/quizImages";

export default function StoryQuizPreview() {
  return (
    <Section>
      <div className="container">
        <SectionHeader
          title="Preview"
          subtitle="Tool for the planeteers to see what each question looks like and if each question has an associated question"
        />
      </div>
      {Object.keys(quiz).map(questionId => {
        const question = quiz[questionId];
        return (
          <QuizQuestionPreview
            title={question.text}
            image={quizImageMap[question.id]}
          >
            <QuizAnswers answers={question.answers} onAnswer={console.info} />
          </QuizQuestionPreview>
        );
      })}
    </Section>
  );
}
